import { render, staticRenderFns } from "./DetailBerlangganan.vue?vue&type=template&id=16dcea12&scoped=true&"
import script from "./DetailBerlangganan.vue?vue&type=script&lang=js&"
export * from "./DetailBerlangganan.vue?vue&type=script&lang=js&"
import style0 from "./DetailBerlangganan.vue?vue&type=style&index=0&id=16dcea12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dcea12",
  null
  
)

export default component.exports